export type RichTextAlignment = "left" | "center" | "right";

const RICH_TEXT_ALIGNMENT_CLASS_NAMES: Record<RichTextAlignment, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

const DEFAULT_RICH_TEXT_ALIGNMENT_CLASS_NAME =
  RICH_TEXT_ALIGNMENT_CLASS_NAMES.left;

export function getRichTextAlignmentClassName(
  textAlign?: string | null,
): string {
  if (!textAlign || textAlign === "left") {
    return DEFAULT_RICH_TEXT_ALIGNMENT_CLASS_NAME;
  }

  if (textAlign in RICH_TEXT_ALIGNMENT_CLASS_NAMES) {
    return RICH_TEXT_ALIGNMENT_CLASS_NAMES[textAlign as RichTextAlignment];
  }

  return DEFAULT_RICH_TEXT_ALIGNMENT_CLASS_NAME;
}
